import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule} from '@angular/material/button';

import { SimpleAutocompleteOverlay } from './simple-autocomplete-overlay.component';
import { VarModule } from '../../directives/ngVar';

@NgModule({
  declarations: [
    SimpleAutocompleteOverlay
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    VarModule
  ],
  exports: [
    SimpleAutocompleteOverlay
  ]
})
export class SimpleAutocompleteOverlayModule { }
